import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";

const AddressDetails = ({ classes, addressDetails }) => {
  const itemView = (label, value) => {
    return (
      <Grid item xs={12} sm={6} md={3} className={classes.fieldContainer}>
        <p style={{ marginBottom: 0 }}>
          <b>{label}</b>
        </p>
        <label>{value}</label>
      </Grid>
    );
  };
  const getAddress = (addresss) => {
    let address = "";
    if (addresss?.houseNumber !== "") {
      address = address + addresss?.houseNumber;
    }
    if (addresss?.street !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.street;
    }
    if (addresss?.locality !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.locality;
    }
    if (addresss?.postOffice !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.postOffice;
    }
    if (addresss?.villageTownCity !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.villageTownCity;
    }
    if (addresss?.state !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.state;
    }
    if (addresss?.district !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.district;
    }
    if (addresss?.pincode !== "") {
      if (address !== "") {
        address = address + ", ";
      }
      address = address + addresss?.pincode;
    }

    return address;
  };
  return (
    <Grid container spacing={2}>
      {/* Title */}
      <Grid item xs={12} className={classes.inputFieldContainer}>
        <h2 className={classes.header} style={{ fontSize: "1.5rem" }}>
          Address Details
        </h2>
      </Grid>

      {/* Reference Details List */}
      <Grid item xs={12} container spacing={2} alignItems="center">
        <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
          <Grid container className={classes.inputFieldContainer} spacing={2}>
            {itemView("Permanent Address", getAddress(addressDetails?.[0]) || "NA")}
            {itemView("Corresponding Address", getAddress(addressDetails?.[1]) || "NA")}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

AddressDetails.propTypes = {
  classes: PropTypes.object,
  referenceDetails: PropTypes.arrayOf(
    PropTypes.shape({
      referalName: PropTypes.string,
      referalRelation: PropTypes.string,
      phoneNumber: PropTypes.string,
    })
  ),
};

export default AddressDetails;
